import { useState, useEffect } from 'react';
import * as Juce from 'juce-framework-frontend';

export const isJuceEnvironment = () => {
    try {
        return typeof Juce.getBackendResourceAddress() === 'string';
    } catch (e) {
        return false;
    }
};

export const getNativeFunction = (name) => {
    return Juce.getNativeFunction(name);
};

export const callNative = async (funcName, args = []) => {
    if (isJuceEnvironment()) {
        try {
            const func = getNativeFunction(funcName);
            if (func) {
                return await func(...args);
            }
        } catch (e) {
            console.warn(`callNative failed for ${funcName}`, e);
            return null;
        }
    }
    return new Promise(resolve => {
        console.log(`[Mock] callNative: ${funcName}`, args);
        if (funcName === 'getPluginList') resolve([]);
        else resolve();
    });
};

export const addJuceListener = (eventId, callback) => {
    if (isJuceEnvironment() && window.__JUCE__ && window.__JUCE__.backend) {
        return window.__JUCE__.backend.addEventListener(eventId, callback);
    }
    if (!window.__mockEvents) window.__mockEvents = {};
    window.__mockEvents[eventId] = callback;
    return eventId;
};

export const removeJuceListener = (id) => {
    if (isJuceEnvironment() && window.__JUCE__ && window.__JUCE__.backend) {
        window.__JUCE__.backend.removeEventListener(id);
    }
    if (window.__mockEvents && window.__mockEvents[id]) {
        delete window.__mockEvents[id];
    }
};
